"use client";

import React, { useState, useEffect } from "react";
import "./SolanaStyles.scss";
import WalletProvider from "../components/WalletProvider";
import AdminDashboard from "../components/AdminDashboard";
import UserPortal from "../components/UserPortal";
import WalletConnect from "../components/WalletConnect";
import { Web3Button } from "../components/web3UI/Web3Button";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { PublicKey } from "@solana/web3.js";
import { getMint, TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { toast } from "react-toastify";
import { Link as RouterLink } from "react-router-dom";
import { Web3ButtonMobile } from "../components/web3UI/Web3ButtonMobile";
import { addresses, supportedChainIds } from "../constants";
import { useDispatch } from "react-redux";
import { useWeb3Context } from "../context";
import tokenLogo from "../images/dashbone.png"; // Import token logo image

// Create a placeholder token logo

// Get mint address from environment variable or fallback to default
const MINT_ADDRESS =
  process.env.REACT_APP_SPL_TOKEN_MINT_ADDRESS ||
  "11111111111111111111111111111112";

const Solana = () => {
  const [activeTab, setActiveTab] = useState("user");
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(false);
  const mintAddress = MINT_ADDRESS;
  const { publicKey, connected } = useWallet();
  const { connection } = useConnection();

  const dispatch = useDispatch();
  const {
    web3Provider,
    connect,
    disconnect,
    network,
    error,
    provider,
    address,
  } = useWeb3Context();

  useEffect(() => {
    const refreshTokenInfo = async () => {
      if (!mintAddress || !connection) return;

      setLoading(true);
      try {
        const mintPubkey = new PublicKey(mintAddress);
        // Use default TOKEN_PROGRAM_ID
        const mintInfo = await getMint(
          connection,
          mintPubkey,
          "confirmed",
          TOKEN_PROGRAM_ID
        );

        // Check if current wallet is admin
        if (publicKey && mintInfo.mintAuthority) {
          setIsAdmin(
            publicKey.toString() === mintInfo.mintAuthority.toString()
          );
        }
      } catch (error) {
        console.error("Error loading token info:", error);
        toast.error("Failed to load token information");
      } finally {
        setLoading(false);
      }
    };
    if (connected) {
      refreshTokenInfo();
    }
  }, [connected, mintAddress, connection, publicKey]);
  return (
    <div className="solana-container">
      <div className="header">
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <div className="container">
            <a className="navbar-brand" href="#">
              <img
                className="main_logo"
                src={require("../images/logo.png")}
                style={{ width: "200px" }}
              />
            </a>
            {/* <RouterLink to={"/dashboard"}>
                                <button className='btn main-btn'>Dashboard</button>
                            </RouterLink> */}
            {/* </NavLink> */}
            <div className="mbl-btns">
              <RouterLink to={"/dashboard"}>
                <span className="navbar-toggler-icon">
                  <i className="fa-solid fa-grid-2"></i>
                </span>
              </RouterLink>
              <Web3ButtonMobile />
            </div>
            {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"><i className="fa-regular fa-wallet"></i></span>
                            </button> */}
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav me-auto mb-2 mb-lg-0 collapse navbar-collapse justify-content-end">
                <li className="nav-item">
                  <a
                    className="nav-link nav-address"
                    href={`https://bscscan.com/address/${addresses[56].dbonAddress}`}
                    target="_blank"
                  >
                    {addresses[56].dbonAddress}
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://twitter.com/DashBone1">
                    <i className="fa-brands fa-twitter"></i>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://discord.gg/KVpw6gjzPf">
                    <i className="fa-brands fa-discord"></i>
                  </a>
                </li>
                <li className="nav-item">
                  <RouterLink className="nav-link" to={"/swap"}>
                    <button className="btn main-btn">Swap Token</button>
                  </RouterLink>
                </li>
                <li className="nav-item">
                  <RouterLink className="nav-link" to={"/dashboard"}>
                    <button className="btn main-btn">Dashboard</button>
                  </RouterLink>
                </li>
                {!address ? (
                  <li className="nav-item">
                    <div
                      onClick={() => toast("Connect wallet to proceed!")}
                      target="_blank"
                      className="nav-link"
                    >
                      <button className="btn main-btn">Dashbone.ai</button>
                    </div>
                  </li>
                ) : (
                  ""
                )}
                {address ? (
                  <li className="nav-item">
                    <a
                      href="https://dashbone.ai/"
                      target="_blank"
                      className="nav-link"
                    >
                      <button className="btn main-btn">Dashbone.ai</button>
                    </a>
                  </li>
                ) : (
                  ""
                )}
                <li className="nav-item">
                  <Web3Button />
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      <header className="solana-header">
        <div className="container">
          <div className="header-content">
            {/* Logo & Title */}
            <div className="logo-section">
              <img src={tokenLogo} alt="Token Logo" className="token-logo" />
              <div className="title-section">
                <h1 className="main-title">SPL Token Manager</h1>
                <p className="subtitle mb-2">Powered by Solana</p>
              </div>
            </div>

            {/* Wallet Connection */}
            <WalletConnect />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="main-content">
        {/* Hero Section */}
        <div className="hero-section">
          <h2 className="hero-title">⚡ Solana Token Hub</h2>
          <p className="hero-description">
            Complete token management solution for Solana SPL tokens. Mint,
            burn, transfer, and manage your tokens with ease.
          </p>
          <div className="badge-container">
            <span className="badge badge-primary d--inline-flex gap-3 align-items-center ">
              <span className="badge-icon">⚡</span>
              Fast & Secure
            </span>
            {isAdmin && (
              <span className="badge badge-admin d--inline-flex gap-3 align-items-center ">
                <span className="badge-icon">🛡️</span>
                Admin Controls
              </span>
            )}
            <span className="badge badge-secondary d--inline-flex gap-3 align-items-center ">
              <span className="badge-icon">👤</span>
              User Friendly
            </span>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="tab-navigation-container">
          {isAdmin && (
            <div className="tab-navigation">
              <button
                className={`btn main-btn tab-btn d-flex align-items-cente gap-2 ${
                  activeTab === "user" ? "active" : ""
                }`}
                onClick={() => setActiveTab("user")}
              >
                <span className="tab-icon">👤</span>
                User Portal
              </button>
              <button
                className={` btn main-btn tab-btn d-flex align-items-center gap-2 ${
                  activeTab === "admin" ? "active" : ""
                }`}
                onClick={() => setActiveTab("admin")}
              >
                <span className="tab-icon">⚙️</span>
                Admin Dashboard
              </button>
            </div>
          )}

          <div className="tab-content">
            {activeTab === "user" && <UserPortal mintAddress={MINT_ADDRESS} />}
            {activeTab === "admin" && (
              <AdminDashboard mintAddress={MINT_ADDRESS} />
            )}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="solana-footer">
        <div className="container">
          <div className="footer-content">
            <div className="row">
              <div className="col-md-6">
                <div className="footer-left">
                  <p className="footer-text">Powered by Genius Mind Zone</p>
                  <p className="footer-mint">
                    Mint Address:{" "}
                    <span className="mint-address">{MINT_ADDRESS}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="footer-right">
                  <div className="footer-links">
                    <a href="#" className="footer-link">
                      Documentation
                    </a>
                    <a href="#" className="footer-link">
                      GitHub
                    </a>
                    <a href="#" className="footer-link">
                      Support
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

const Wrapper = () => {
  return (
    <WalletProvider>
      <Solana />
    </WalletProvider>
  );
};

export default Wrapper;
